export class AppPageHeader {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent.parent;
    }
}
